import React from 'react'
import ArrowIcon from '../arrow-icon/ArrowIcon'
import classnames from 'classnames'
import { ViewerContext } from '../context/ViewerContext'
import PaginatorNavigation from './PaginatorNavigation'
import PaginatorNavigationCatalog from './PaginatorNavigationCatalog'
import { debounce } from '../helpers'
import { paginatorProps } from '../types'
import Tooltip from '../tooltip/Tooltip'
class Paginator extends React.Component {
  static propTypes = paginatorProps
  constructor(props) {
    super(props)
    this.state = {
      scrollLeft: false,
      scrollRight: true,
      currentPage: null,
    }
    this.debouncedGetSetHeight = debounce(this.getSetHeight, 250)
    this.itemWidth = 94 + 20 //width + margin
  }
  componentDidMount() {
    if (this.context.state.paginatorPosition < -200) {
      this.setState({ scrollLeft: true })
    }
    if (this.context.state.paginatorOpen == 'full') {
      this.getSetHeight(this.context.state.paginatorHeight)
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const currentPage = document.querySelector(
      '.paginator__list__item .current'
    )
    if (currentPage) {
      if (prevState.currentPage !== currentPage) {
        this.setState({ currentPage })
        this.setCarouselPosition('right', this.state.currentPage)
      }
    }
  }

  paginatorToggle = () => {
    let paginatorOpen = this.props.paginatorOpen
    if (paginatorOpen === 'half' || paginatorOpen === 'full') {
      this.props.setPaginatorState('closed')
    } else {
      this.props.setPaginatorState('half')
    }
  }
  getSetHeight = height => {
    const paginator = document.querySelector('.js-paginator')
    if (height) {
      paginator.style.height = height
    } else {
      let paginatorHeight = document
        .querySelector('.js-paginator__carousel')
        .getBoundingClientRect().height
      const newHeight = paginatorHeight * 5 + 'px'
      paginator.style.height = newHeight
    }
  }
  viewAllToggle = size => {
    this.props.setPaginatorState(size)
    if (size === 'full') {
      this.debouncedGetSetHeight()
    } else {
      document.querySelector('.js-paginator').style.removeProperty('height')
    }

    document.querySelector('.js-paginator__carousel').style.left = '0'
    this.setState({
      scrollLeft: false,
      scrollRight: true,
    })
  }
  renderViewAllIcon = () => {
    return (
      <svg viewBox="0 0 12 11" xmlns="http://www.w3.org/2000/svg">
        <g stroke="#74716C" fill="none">
          <path d="M.5.5h1.182v1H.5zm3.273 0h1.182v1H3.773zm3.272 0h1.182v1H7.045zm3.273 0H11.5v1h-1.182zM.5 3.5h1.182v1H.5zm3.273 0h1.182v1H3.773zm3.272 0h1.182v1H7.045zm3.273 0H11.5v1h-1.182zM.5 6.5h1.182v1H.5zm3.273 0h1.182v1H3.773zm3.272 0h1.182v1H7.045zm3.273 0H11.5v1h-1.182zM.5 9.5h1.182v1H.5zm3.273 0h1.182v1H3.773zm3.272 0h1.182v1H7.045zm3.273 0H11.5v1h-1.182z" />
        </g>
      </svg>
    )
  }
  renderViewAllBtn = () => {
    if (this.props.paginatorOpen == 'half') {
      return (
        <Tooltip tooltipPosition="above" tooltipText="View All">
          <button
            className="paginator-view-all"
            onClick={() => this.viewAllToggle('full')}
            type="button"
          >
            {this.renderViewAllIcon()}
          </button>
        </Tooltip>
      )
    } else {
      return (
        <Tooltip tooltipPosition="above" tooltipText="View Fiewer">
          <button
            className="paginator-view-all"
            onClick={() => this.viewAllToggle('half')}
            type="button"
          >
            {this.renderViewAllIcon()}
          </button>
        </Tooltip>
      )
    }
  }

  getCarouselWidth = () => {
    const width = this.props.totalPages * this.itemWidth
    return width
  }
  setCarouselPosition = (direction, currentPage) => {
    const carousel = document.querySelector('.js-paginator__carousel')
    const carouselFrame = document.querySelector('.js-paginator__list__frame')
    const frameWidth = parseInt(carouselFrame.offsetWidth)
    const totalPages = this.props.totalPages
    const totalWidth = totalPages * this.itemWidth - this.itemWidth
    let currentLeft = carousel.style.left ? parseInt(carousel.style.left) : 0
    let newLeft = 0
    if (currentPage) {
      const currentPageLeft = parseInt(
        currentPage.closest('.paginator__list__item').offsetLeft
      )
      if (currentPageLeft > frameWidth) {
        newLeft = -(currentPageLeft - frameWidth / 2)
        this.setState({
          scrollLeft: true,
        })
      }
    } else {
      if (direction === 'next') {
        newLeft =
          currentLeft + frameWidth - this.itemWidth * 2 >
          -totalWidth + 1.5 * frameWidth
            ? currentLeft - frameWidth + this.itemWidth
            : currentLeft
      } else {
        newLeft =
          currentLeft + frameWidth <= totalPages
            ? currentLeft + frameWidth
            : totalPages
      }
    }
    if (0 > newLeft && newLeft === currentLeft) {
      this.setState({
        scrollRight: false,
        scrollLeft: true,
      })
    } else if (0 < newLeft && newLeft === currentLeft) {
      this.setState({
        scrollRight: true,
        scrollLeft: false,
      })
    } else if (newLeft < -1 * carousel) {
      this.setState({
        scrollLeft: true,
        scrollRight: false,
      })
    } else {
      this.setState({
        scrollLeft: true,
        scrollRight: true,
      })
    }
    this.context.updatePaginatorPosition(newLeft)
    return (carousel.style.left = newLeft + 'px')
  }
  renderPaginator(viewerType, tilePrefix) {
    if (viewerType === 'viewer') {
      return <PaginatorNavigation tilePrefix={tilePrefix} />
    } else {
      return <PaginatorNavigationCatalog tilePrefix={tilePrefix} />
    }
  }
  render() {
    const renderContainerClasses = classnames('paginator js-paginator', {
      'paginator--closed': this.props.paginatorOpen == 'closed',
      'paginator--full ': this.props.paginatorOpen == 'full',
    })
    const inlineStyle = {
      left: this.context.state.paginatorPosition,
      width:
        this.props.paginatorOpen == 'half' ? this.getCarouselWidth() : 'auto',
    }
    return (
      <div className={renderContainerClasses} tabIndex="-1">
        <div className="paginator__list">
          <button
            className="paginator__list__btn paginator__list__btn--previous"
            onClick={() => this.setCarouselPosition('previous')}
            disabled={
              this.state.scrollLeft && this.props.paginatorOpen === 'half'
                ? false
                : true
            }
            type="button"
          >
            <ArrowIcon />
            <span className="visually-hidden">Previous</span>
          </button>
          <div className="paginator__list__frame js-paginator__list__frame">
            <div
              className="js-paginator__carousel paginator__carousel"
              style={inlineStyle}
            >
              {this.renderPaginator(
                this.props.viewerType,
                this.props.tilePrefix
              )}
            </div>
          </div>
          <button
            className="paginator__list__btn--next paginator__list__btn"
            onClick={() => this.setCarouselPosition('next')}
            disabled={
              this.state.scrollRight && this.props.paginatorOpen === 'half'
                ? false
                : true
            }
            type="button"
          >
            <ArrowIcon />
            <span className="visually-hidden">Next</span>
          </button>
        </div>
        {this.renderViewAllBtn()}
      </div>
    )
  }
}
Paginator.contextType = ViewerContext

export default Paginator
